import { hbs } from 'ember-cli-htmlbars';
export default hbs("<ul class=\"nw-tabs-2\" ...attributes>\n  {{yield (component \"nw-nav-tab\" model=@model)}}\n</ul>")